module.exports = __webpack_public_path__ + "media/img/private-venue/experience-9ae686a1dfd0a9812c137d56e1aaf9de.svg";